import React, { useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { Link, useParams } from "react-router-dom";
import { getDocData, setDocData } from "../../../utils/firebase/Firebase.utils";
import {
  FiBell,
  FiClock,
  FiMessageSquare,
  FiCheck,
  FiExternalLink,
  FiArrowLeft,
} from "react-icons/fi";
import IOSSpinner from "../../../components/IOSSpinner";

function NotificationDetails() {
  const { id } = useParams();
  const [notification, setNotification] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    const fetchNotification = async () => {
      const data = await getDocData("notifications", id);
      setNotification(data);
      setIsLoading(false);
    };
    fetchNotification();
  }, []);

  //update the notification to read when message is opened
  useEffect(() => {
    if (notification) {
      setDocData("notifications", id, { ...notification, read: true });
    }
  }, [notification, id]);

  if (isLoading) {
    return (
      <UserScreenWindow>
        <div className="flex items-center justify-center min-h-[400px]">
          <IOSSpinner />
        </div>
      </UserScreenWindow>
    );
  }

  const date = notification.dateTime.toDate().toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <UserScreenWindow label="Notifications">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
          {/* Header */}
          <div
            className="p-5 border-b border-gray-100"
            style={{ backgroundColor: "rgba(54, 48, 98, 0.03)" }}
          >
            <div className="flex items-center gap-3 mb-3">
              <div
                className="p-2 rounded-lg"
                style={{ backgroundColor: "rgba(54, 48, 98, 0.08)" }}
              >
                <FiBell className="w-4 h-4" style={{ color: "#363062" }} />
              </div>
              <h1 className="text-lg font-medium" style={{ color: "#363062" }}>
                {notification.subject}
              </h1>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <FiClock className="w-3.5 h-3.5" />
              <span>{date}</span>
            </div>
          </div>

          {/* Content */}
          <div className="p-5">
            <div className="flex items-start gap-4">
              <div
                className="p-2 rounded-lg mt-1"
                style={{ backgroundColor: "rgba(143, 205, 0, 0.08)" }}
              >
                <FiMessageSquare
                  className="w-4 h-4"
                  style={{ color: "#8FCD00" }}
                />
              </div>
              <div className="flex-1">
                <div className="text-sm text-gray-600 leading-relaxed mb-6">
                  {notification.message}
                </div>

                {notification?.url && (
                  <div className="space-y-4">
                    <Link
                      to={notification.url}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm text-white rounded-lg transition-all duration-200 hover:translate-y-[-1px] hover:shadow-md"
                      style={{ backgroundColor: "#363062" }}
                    >
                      <FiExternalLink className="w-4 h-4" />
                      <span>View Details</span>
                    </Link>
                  </div>
                )}

                <div
                  className="flex items-center gap-2 mt-4 text-xs"
                  style={{ color: "#8FCD00" }}
                >
                  <FiCheck className="w-4 h-4" />
                  <span>Message read</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default NotificationDetails;